import React from 'react';
import {StripeProvider, Elements} from 'react-stripe-elements';
import { STRIPEKEY } from '../../constants'
import AchPaymentForm from './AchPaymentForm';
 
const AchPayment = (props) => {
  return (
    <StripeProvider apiKey={STRIPEKEY}>
		<Elements>
			<AchPaymentForm {...props}/>
		</Elements>
    </StripeProvider>
  );
};
export default AchPayment;


// WEBPACK FOOTER //
// ./src/components/ui/AchPayment.js